/* ============================================================
   PRO MODE — suis per-browser + kiraan blocks tersimpan (live)
   ============================================================
   Rujukan: PLAN_PROSTUDIO_BLOCKS.md (bahagian 2).

   DUA simpanan, sengaja berasingan (corak sama CTA beg kuning):
     • SUIS "Pro Mode hidup/mati" → localStorage, milik BROWSER INI.
       Pelanggan guna 3–5 browser serentak; semua tetapan larian ikut
       per-browser sejak 2026-08-25 supaya menukar suis di satu browser
       tidak menukar larian browser lain yang sedang berjalan.
     • BLOCKS → Firestore `users/{uid}/proBlocks/{moduleId}`, milik AKAUN.
       Hook ini hanya MEMBACA (onSnapshot satu doc kecil) untuk baris
       status "GOYANG · N blocks" dan pagar "Pilih blocks dulu".

   ⛔ Suis ditulis HANYA dari pengendali klik (`setHidup`), tidak pernah
      dari useEffect — effect turut berjalan pada mount dan akan mengunci
      setiap browser pada nilai lalai (perangkap `sesaat_products_paparan_v2`).

   ⛔ Tiada setState di dalam badan effect (lint `set-state-in-effect`);
      keadaan "tidak diaktifkan" DIKIRA semasa render, bukan di-set.
   ============================================================ */

import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../firebase';
import { PRO_BLOK_COL } from '../utils/proBlokStore';

const KUNCI = 'sesaat_pro_mode_v1';

const bacaPeta = () => {
    try {
        const p = JSON.parse(localStorage.getItem(KUNCI) || '{}');
        return p && typeof p === 'object' ? p : {};
    } catch {
        return {};
    }
};

export const bacaProMode = (moduleId) => bacaPeta()[moduleId] === true;

export const tulisProMode = (moduleId, hidup) => {
    try {
        const p = bacaPeta();
        p[moduleId] = !!hidup;
        localStorage.setItem(KUNCI, JSON.stringify(p));
    } catch {
        /* mod privasi boleh melempar — suis kekal dalam ingatan sahaja */
    }
};

const BLOK_KOSONG = { sudahMuat: false, ada: false, bilangan: 0, ralat: '' };

/* `enabled` = isAdmin && sudah log masuk (Fasa 1 admin sahaja). Bila
   false, tiada langganan Firestore langsung — pelanggan biasa tidak
   membayar satu bacaan pun untuk ciri yang mereka tidak nampak. */
export function useProMode(moduleId, enabled) {
    const [hidup, setHidupState] = useState(() => bacaProMode(moduleId));
    const [blok, setBlok] = useState(BLOK_KOSONG);

    const setHidup = (v) => {
        tulisProMode(moduleId, v);
        setHidupState(!!v);
    };

    useEffect(() => {
        if (!enabled) return undefined;
        const uid = auth.currentUser?.uid;
        if (!uid) return undefined;
        const unsub = onSnapshot(
            doc(db, 'users', uid, PRO_BLOK_COL, moduleId),
            (snap) => {
                const d = snap.exists() ? snap.data() : null;
                const n = Array.isArray(d?.blocks) ? d.blocks.length : 0;
                setBlok({ sudahMuat: true, ada: n > 0, bilangan: n, ralat: '' });
            },
            (err) => {
                /* Gagal baca = beritahu, bukan pura-pura "tiada blocks". */
                console.warn('[useProMode] gagal membaca blocks:', err?.message);
                setBlok({ sudahMuat: true, ada: false, bilangan: 0, ralat: err?.code || 'ralat' });
            },
        );
        return unsub;
    }, [moduleId, enabled]);

    return { hidup, setHidup, ...(enabled ? blok : BLOK_KOSONG) };
}
